export default __webpack_public_path__ + "static/media/vm-dummy-banner.748ea335.png";